import Candidates from './dashboardRoutes/CandidateRoutes';
import Jobs from './dashboardRoutes/JobsRoutes';
import Contacts from './dashboardRoutes/ContactRoutes';
import Company from './dashboardRoutes/CompanyRoutes';
import Teams from './dashboardRoutes/TeamsRoutes';
import Tasks from './dashboardRoutes/TaskManagerRoutes';
import Common from './dashboardRoutes/CommonRoutes';
import Onboarding from './dashboardRoutes/OnboardingRoutes';

export const namedPages = [...Candidates, ...Jobs, ...Contacts, ...Company, ...Teams, ...Tasks, ...Onboarding, ...Common];

export const namedPatterns = () => {
    const patterns = namedPages.map((p) => p.path);
    return patterns;
};

export default function getPageTitle(location: string): string {
    // TODO Verify this for location with parameters
    const currentPage = namedPages.find((p) => p.path === location);
    if (currentPage) {
        return currentPage.title;
    }

    return `No name for page at ${location}`;
}
